<template>
<div class="chapter">
<div class="inner_page">
<section class="SOM" epub:type="toc" role="doc-toc">
<h1 class="SOM_titre" epub:type="title">CONTENTS</h1>
<div class="SOM_pre"><a href="#/Text/pre2">Foreword by John M. Perkins</a></div>
<div class="SOM_pre"><a href="#/Text/pre3">Preface to the Signature Edition</a></div>
<div class="SOM_pre"><a href="#/Text/pre4">Acknowledgments</a></div>
<div class="SOM_pre"><a href="#/Text/pre5">Introduction</a></div>
<div class="SOM_chap"><a href="#/Text/chap1">1  Is There Still a Race Problem?</a></div>
<div class="SOM_chap"><a href="#/Text/chap2">2  Mission Impossible?</a></div>
<div class="SOM_chap"><span href="#/Text/chap3" title="Link target outside of Sample">3  A Better Way</span></div>
<div class="SOM_chap"><span href="#/Text/chap4" title="Link target outside of Sample">4  A New Model</span></div>
<div class="SOM_chap"><span href="#/Text/chap5" title="Link target outside of Sample">5  How Worship Builds Bridges</span></div>
<div class="SOM_chap"><span href="#/Text/chap6" title="Link target outside of Sample">6  Embracing Our True Selves</span></div>
<div class="SOM_chap"><span href="#/Text/chap7_1" title="Link target outside of Sample">7  Receiving and Extending Forgiveness</span></div>
<div class="SOM_chap"><span href="#/Text/chap8" title="Link target outside of Sample">8  Denouncing the Powers and Principalities</span></div>
<div class="SOM_chap"><span href="#/Text/chap9" title="Link target outside of Sample">9  Ongoing Partnerships</span></div>
<div class="SOM_chap"><span href="#/Text/chap10" title="Link target outside of Sample">10  The Trumpet Call</span></div>
<div class="SOM_appen"><span href="#/Text/appen6" title="Link target outside of Sample">Reconciliation Generation Commitment</span></div>
<div class="SOM_appen"><span href="#/Text/appen7" title="Link target outside of Sample">Appendix 1: Definitions</span></div>
<div class="SOM_appen"><span href="#/Text/appen8" title="Link target outside of Sample">Appendix 2: The Principalities and Powers</span></div>
<div class="SOM_appen"><span href="#/Text/appen9" title="Link target outside of Sample">Appendix 3: Exploring the Heart of Racial Justice: A Strategic Tool for Leaders</span></div>
<div class="SOM_appen"><span href="#/Text/appen10" title="Link target outside of Sample">Notes</span></div>
<div class="SOM_appen"><span href="#/Text/appen11" title="Link target outside of Sample">Bibliography</span></div>
<div class="SOM_appen"><span href="#/Text/appen12" title="Link target outside of Sample">Recommended Resources</span></div>
<div class="SOM_appen"><span href="#/Text/appen16" title="Link target outside of Sample">Praise for <i>The Heart of Racial Justice</i></span></div>
<div class="SOM_appen"><span href="#/Text/appen17" title="Link target outside of Sample">About the Authors</span></div>
<div class="SOM_appen"><span href="#/Text/appen13" title="Link target outside of Sample">Also Available</span></div>
<div class="SOM_appen"><span href="#/Text/appen14" title="Link target outside of Sample">The IVP Signature Collection</span></div>
<div class="SOM_pdf"><span href="#/Text/fin_acheve" title="Link target outside of Sample">More Titles from InterVarsity Press</span></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sommaire.vue?f728ab00